import ChatMessagesTickets from "components/ChatMessagesTickets";
import OnlyHeader from "components/Headers/OnlyHeader";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import AssignTicketModal from "components/Modals/ticketsModal/AssignTicketModal";
import { socket } from "config/socketConfig";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Button, Card, CardHeader, Container, Row, Spinner } from "reactstrap";
import {
  changeTicketStatusAction,
  getSingleTicket,
} from "store/actions/ticketsAction";

const TicketsDetails = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const dispatch = useDispatch();
  const { id } = useParams();
  const { singleTicket, allTicketsLoader } = useSelector(
    (state) => state.tickets,
  );
  const { user } = useSelector((state) => state.auth);
  console.log(">>>singleTicket: ", singleTicket);
  const [ticketChat, setTicketChat] = useState();
  const history = useHistory();
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [message, setMessage] = useState("");
  const [userId, setUserId] = useState("");

  const handleGoBack = () => {
    history.goBack();
  };

  const toggleConfirmationModal = () => {
    setConfirmationModal(!confirmationModal);
  };

  const handleMarkAsResolveModal = (id) => {
    setUserId(id);
    setMessage("Are you sure you want to mark as resolve this ticket?");
    toggleConfirmationModal();
  };

  const handleReopenTicketModal = (id) => {
    setUserId(id);
    setMessage("Are you sure you want to reopen ticket this ticket?");
    toggleConfirmationModal();
  };

  const handleResolveConfirmationOk = () => {
    console.log("userId: ", userId);
    singleTicket?.status === "closed"
      ? dispatch(changeTicketStatusAction(userId, "in progress"))
      : dispatch(changeTicketStatusAction(userId, "closed"));
    toggleConfirmationModal();
  };

  const handleConfirmationCancel = () => {
    toggleConfirmationModal();
  };

  useEffect(() => {
    dispatch(getSingleTicket(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (singleTicket) {
      setTicketChat(singleTicket);
    }
  }, [singleTicket]);

  useEffect(() => {
    const handleNewComment = (data) => {
      const payload = Array.isArray(data) ? data[0] : data;
      console.log("newComment", payload);

      const payloadTicketId =
        payload?.ticketId ||
        payload?.ticket?._id ||
        payload?.comment?.ticketId ||
        payload?.comment?.ticket?._id;

      if (!payloadTicketId || payloadTicketId === id) {
        // dispatch(getSingleTicket(id));
        dispatch({
          type: "EMBED_SINGLE_TICKET_COMMENT_BY_SOCKET",
          payload: payload,
        });
      }
    };

    const handleConnectJoinTicket = () => {
      socket.emit("joinTicket", id);
    };

    if (user?.id) {
      socket.auth = {
        ...(socket.auth || {}),
        userId: user.id,
      };
    }

    if (!socket.connected) {
      socket.off("connect", handleConnectJoinTicket);
      socket.on("connect", handleConnectJoinTicket);
      socket.connect();
    } else {
      socket.emit("joinTicket", id);
    }

    socket.off("newComment", handleNewComment);
    socket.on("newComment", handleNewComment);

    return () => {
      socket.emit("leaveTicket", id);
      socket.off("connect", handleConnectJoinTicket);
      socket.off("newComment", handleNewComment);
    };
  }, [dispatch, id, user?.id]);

  return (
    <>
      <AssignTicketModal
        modal={modal}
        toggle={toggle}
        singleTicket={singleTicket}
      />

      <ConfirmationModal
        modal={confirmationModal}
        toggle={toggleConfirmationModal}
        userId={userId}
        message={message}
        onConfirm={handleResolveConfirmationOk}
        onCancel={handleConfirmationCancel}
      />

      <OnlyHeader />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-lg-flex justify-content-between align-items-center">
                <h3
                  className="mb-0 cursor-pointer text-sm"
                  onClick={handleGoBack}
                >
                  <i className="fas fa-chevron-left mr-1"></i>Ticket Details
                </h3>
                <div className="d-flex flex-wrap justify-content-end align-items-center mt-2 mt-lg-0">
                  {singleTicket?.assignedTo === null ? (
                    <Button
                      size="sm"
                      color="primary"
                      onClick={() => {
                        toggle();
                      }}
                    >
                      Assign Ticket
                    </Button>
                  ) : (
                    <Button size="sm" color="primary" disabled>
                      Already Assigned
                    </Button>
                  )}

                  {singleTicket?.status === "closed" ? (
                    <Button size="sm" color="primary" disabled>
                      Closed
                    </Button>
                  ) : (
                    <Button
                      size="sm"
                      color="primary"
                      onClick={() => handleMarkAsResolveModal(id)}
                    >
                      Mark As Resolve
                    </Button>
                  )}
                  {singleTicket?.status === "in progress" ? (
                    <Button size="sm" color="primary" disabled>
                      In Progress
                    </Button>
                  ) : (
                    <Button
                      size="sm"
                      color="primary"
                      onClick={() => handleReopenTicketModal(id)}
                    >
                      Reopen Ticket
                    </Button>
                  )}
                </div>
              </CardHeader>

              <div className="p-2 p-lg-5">
                <div className="d-md-flex justify-content-between mb-3">
                  <div className="d-flex align-items-center">
                    <h4 className="mb-0 mr-1">Status :</h4>
                    <p className="mb-0 text-capitalize">
                      {singleTicket?.status}
                    </p>
                  </div>
                  <div className="d-flex align-items-center">
                    <h4 className="mb-0 text-capitalize mr-1">Created By : </h4>
                    <p className="mb-0">
                      {singleTicket?.createdBy?.firstName}{" "}
                      {singleTicket?.createdBy?.lastName}
                    </p>
                  </div>
                  <div className="d-flex align-items-center">
                    <h4 className="mb-0 mr-1">Ticket No:</h4>
                    <p className="mb-0">{singleTicket?.ticketNumber}</p>
                  </div>
                </div>
                {singleTicket?.subject && (
                  <div className="d-md-flex align-items-start mb-2">
                    <h4 className="mb-0 mr-2" style={{ whiteSpace: "nowrap" }}>
                      Subject :{" "}
                    </h4>
                    <p
                      className="mb-0 text-capitalize text-break"
                      style={{ wordBreak: "break-word" }}
                    >
                      {singleTicket?.subject}
                    </p>
                  </div>
                )}
                {singleTicket?.description && (
                  <div className="mb-2">
                    <h4 className="mb-0">Description :</h4>
                    <p
                      className="mb-1 text-break"
                      style={{
                        wordBreak: "break-word",
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {singleTicket?.description}
                    </p>
                  </div>
                )}
                {allTicketsLoader ? (
                  <Row className="d-flex justify-content-center">
                    <Spinner size="sm" />
                  </Row>
                ) : (
                  <ChatMessagesTickets ticketChat={ticketChat} />
                )}
              </div>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default TicketsDetails;
